import React, { useState } from 'react';
import PatientMiniProfile from '../../../../Components/PatientMiniProfile/PatientMiniProfile';
import { useAppContext } from '../../../../Services/AppContext';
import { joinClasses } from '../../../../Utils/className.util';

// @ts-ignore
import styles from './PatientTreatmentPageWrapper.module.scss';

interface PatientTreatmentMiniProfileProps {
	patientId: string;
	children: React.ReactElement | React.ReactElement[];
}

const PatientTreatmentPageWrapper: React.FC<
	PatientTreatmentMiniProfileProps
> = props => {
	const { patientId, children } = props;
	const {
		userData: { id: loggedUserId },
		workplaceId,
		globalTemplate,
	} = useAppContext();
	const [showMiniProfile, setShowMiniProfile] = useState<boolean>(true);

	const handleToggleProfile = () => {
		setShowMiniProfile(prevValue => !prevValue);
	};

	return (
		<>
			<div className={styles.profile}>
				{showMiniProfile && (
					<PatientMiniProfile
						allowOpenProfile={false}
						userId={patientId}
						workplaceId={workplaceId}
						loggedUserId={loggedUserId}
						showVerifyInformation
						links={null}
						showAge={false}
						showBirthDate
						showAddress
						showPhone={false}
						showEmail={false}
						showInsuranceCompany={globalTemplate !== 'hungary'}
						showGender={false}
					/>
				)}
				<div
					className={joinClasses([
						styles.arrow,
						showMiniProfile ? styles.arrowUp : styles.arrowDown,
					])}
					onClick={() => handleToggleProfile()}
				/>
			</div>
			{children}
		</>
	);
};

export default PatientTreatmentPageWrapper;
